import { z } from "zod";

export const SlotKindSchema = z.enum(["text", "oneline", "micropost", "image"]);
export type SlotKind = z.infer<typeof SlotKindSchema>;

export const ItemPhaseSchema = z.enum([
  "inbox",
  "editing",
  "signoff",
  "backlog",
]);
export type ItemPhase = z.infer<typeof ItemPhaseSchema>;

export const SlotVersionSchema = z.object({
  name: z.string(),
  kind: SlotKindSchema,
  blobSlug: z.string().nullable(),
});
export type SlotVersion = z.infer<typeof SlotVersionSchema>;

export const ItemVersionSchema = z.object({
  slug: z.string(),
  version: z.number(),
  phase: ItemPhaseSchema,
  slots: z.array(SlotVersionSchema),
  createdAt: z.string(),
  niceName: z.string().nullable(),
  sourceSlug: z.string().nullable(),
});
export type ItemVersion = z.infer<typeof ItemVersionSchema>;
